// UIkit Icons
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);

global.$ = global.jQuery = jQuery;
global.UIkit = UIkit;
global.Vue = Vue;
global.axios = axios;

global.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const breakPoints = {
    small:  600,
    medium: 768,
    large:  1000,
    xlarge: 1200,
};

export const breakPointsMax = {
    small:  600 - 1,
    medium: 768 - 1,
    large:  1000 - 1,
    xlarge: 1200 - 1,
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js